<template>
  <v-container>
    <h6>IMPACTO AMBIENTAL DE LA PLANTA DE ELECTROINGENIERÍA ICS SA</h6>
    Todas las <b>actividades humanas</b> generan un <b>impacto ambiental</b>,
    positivo o negativo. En nuestra empresa, se ha realizado un estudio de
    cuáles son los impactos ambientales que genera el funcionamiento de la
    <b>planta de fabricación y las oficinas</b>. Este estudio se realiza en un
    formulario llamado
    <b>
      <font color="#008000">Form. EI 305: Evaluación de impacto ambiental.</font>
    </b>
    <v-row>
      <v-col cols="12" sm="10" md="10">
        A continuación detallamos los
        <b>impactos ambientales más significativos de nuestra planta.</b> En
        cada uno de ellos, se encuentra un link con los indicadores
        correspondientes, en caso de existir, y material informativo con
        acciones se pueden tomar para reducir los mismos. Incluimos también los
        <b>objetivos de desarrollo sostenible (ODS)</b> asociados, como una
        manera de mostrar cómo contribuye Electroingeniería ICS SA, mediante el
        cumplimiento de sus objetivos, al cumplimiento de la
        <b>Agenda 2030</b> de las Naciones Unidas. Más información sobre los
        ODS, hacer click
        <a target="_blank" href="https://www.un.org/sustainabledevelopment/es/">aquí</a>.
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-img src="images/ods-1.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="green">
        <font color="#FFFFFF">MATERIAS PRIMAS Y MATERIALES</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Materias primas y materiales</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">Ciclo de Vida:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/Documentos/MI5.03.03.01.pdf?' + Math.random()">- Ciclo de vida de
              celdas y tableros</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/Documentos/MI5.03.03.02.pdf?' + Math.random()">- Ciclo de vida de
              salas prefabricadas de hormigón para uso
              eléctrico</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="3" sm="3"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="3" sm="3">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="green">
        <font color="#FFFFFF">ENERGÍA</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Energía Eléctrica</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicadores:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G12.asp"> - G12: Consumo de
              energía eléctrica en kWh per cápita.</a>
          </font>
        </p>

        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G12F.asp">-
              G12F: Consumo de energía eléctrica en kWh per cápita en
              Fabricación.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G12AC.asp"> - G12AC: Consumo de
              energía eléctrica en kWh per cápita
              de áreas complementarias a la producción.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank"
              href="http://192.168.11.201/intranet/indicadores/graficos/G12BA.asp">- G12BA: Consumo de energía eléctrica
              en kWh per cápita en Sucursal
              Bs As.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E11.asp">-
              E11: Utilización energía eléctrica / kg de metal ferroso
              procesado.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E20.asp">-
              E20: Generación de Energía Eléctrica Renovable / Consumo de
              Energía Eléctrica Total.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E21.asp">-
              E21: Generación de Energía Eléctrica Renovable / Pronóstico
              esperado de Generación de Energía Eléctrica Renovable.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Consejos_reducir_consumo_energiaelectrica.pdf?' + Math.random()">
              - Consejos para reducir el consumo de energía eléctrica</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="8" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods7.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="8" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="8" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
      <v-col cols="8" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods13.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Combustibles</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicador:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G16.asp"> - G16: Consumo de
              combustibles en litros.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Consejos_reducir_consumo_combustible.pdf?' + Math.random()">
              - Consejos para reducir el consumo de combustibles</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="3" sm="3"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="3" sm="3">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Gas Natural</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicadores:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G14.asp"> - G14: Consumo de gas
              en m3 per cápita.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G14BA.asp"> - G14BA: Consumo de
              gas en m3 per cápita en Sucursal Bs As.</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000">
            <a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Consejos_reducir_consumo_gas.pdf?' + Math.random()">
              - Consejos para reducir el consumo de gas natural</a>
          </font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="3" sm="3"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="3" sm="3">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="green">
        <font color="#FFFFFF">AGUA</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Agua</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicadores:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/G10.asp">-
              G10: Consumo de agua potable por
              persona por mes.</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Consejos_reducir_consumo_agua.pdf?' + Math.random()">-
              Consejo para reducir el consumo de agua</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="3" sm="3"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="3" sm="3">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods6.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="green">
        <font color="#FFFFFF">PAPEL</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#008000">Papel</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#008000"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Consejos_reducir_consumo_papel.pdf?' + Math.random()">-
              Consejo para reducir el consumo de papel</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods15.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" ms="12" sm="12" align="center">
        <v-img src="images/image002.jpg" max-height="200px" max-width="200px"></v-img>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" style="background-color: #CC3300;">
        <font color="#FFFFFF">PRODUCTOS</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#CC3300">Productos terminados</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Disposicionfinal.pdf?' + Math.random()">-
              Disposición final de los materiales utilizados en los productos
              fabricados.</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods11.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" style="background-color: #CC3300;">
        <font color="#FFFFFF">RESIDUOS</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#CC3300">Residuos convencionales</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicadores:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E10.asp">-
              E10: Scrap de chapa y perfiles acero / kg de metal ferroso
              procesado.</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E12.asp">
              - E12: Scrap de cobre / kg de metal ferroso procesado.</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Material Informativo:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300"><a target="_blank"
              :href="'https://api.icssa.com.ar/SGI/ImpactoAmbiental/Clasificacionresiduos.pdf?' + Math.random()">-
              Clasificación de residuos.</a></font>
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="LIGTH-green">
        <p>
          <font color="#CC3300">Residuos peligrosos</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#000000">Indicadores:</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300"><a target="_blank" href="http://192.168.11.201/intranet/indicadores/graficos/E14.asp">-
              E14: Generación de residuos peligrosos.</a></font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          Objetivo de desarrollo sostenible (ODS) asociado:
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods11.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" style="background-color: #CC3300;">
        <font color="#FFFFFF">EMISIONES</font>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12">
        <p>
          <font color="#CC3300">Humos de soldaduras</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">- Informe de humos de soldadura.</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">(ver con Responsable de SST y MA)</font>
        </p>
        <p></p>
        <p>
          <font color="#CC3300">Vapores y compuestos volátiles</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">- Informe de vapores y compuestos volátiles en cabina de
            pintura.</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">- Informe de vapores y compuestos volátiles en estañado.</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">(ver con Responsable de SST y MA)</font>
        </p>
        <p></p>
        <p>
          <font color="#CC3300">Ruidos</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">- Informe de ruidos en vecindario.</font>
        </p>
        <p style="margin-top: 0; margin-bottom: 0">
          <font color="#CC3300">(ver con Responsable de SST y MA)</font>
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" md="2" sm="2"><a href="https://www.un.org/sustainabledevelopment/es/"><v-img src="images/ods9.jpg"
            max-height="100px" max-width="100px"></v-img></a>
      </v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods11.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
      <v-col cols="6" md="2" sm="2">
        <a href="https://www.un.org/sustainabledevelopment/es/">
          <v-img src="images/ods12.jpg" max-height="100px" max-width="100px"></v-img></a></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  mounted() {
    if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
      this.$store.dispatch("logout");
    } else {
      this.$store.state.sector = "ICSSA";
    }
  },
};
</script>
